export const ScheduleView = () => {
  return (
    <div data-testid='schedule'>
      <p>Schedule</p>
    </div>
  )
}
